'use client';

import { useEffect } from 'react';

const FONT_AWESOME_URL = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
const ICON_SELECTOR = '.fa,.fas,.far,.fab,.fal,.fad,.fat,.fass,.fasr,.fasl,.fast,.fa-solid,.fa-regular,.fa-brands,.fa-light,.fa-thin,.fa-duotone,.fa-sharp';

/** Modra uses SVG icons. CMS HTML may still introduce a Font Awesome icon. */
export function HeadExternalAssets() {
  useEffect(() => {
    let loaded = false;
    const loadFor = (node: Element) => {
      if (loaded || (!node.matches(ICON_SELECTOR) && !node.querySelector(ICON_SELECTOR))) return;
      loaded = true;
      observer.disconnect();
      if (document.querySelector('link[data-modra-font-awesome]')) return;
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = FONT_AWESOME_URL;
      stylesheet.dataset.modraFontAwesome = 'true';
      document.head.appendChild(stylesheet);
    };
    // Retain support for icons inserted by streamed HTML, navigation or dialogs.
    // Inspect only changed subtrees, not the entire page on every mutation.
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (loaded) break;
        if (record.type === 'attributes' && record.target instanceof Element) loadFor(record.target);
        for (const node of record.addedNodes) {
          if (node instanceof Element) loadFor(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    loadFor(document.body);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Images use the default (non-CORS) request mode; use its connection pool. */}
      <link rel="preconnect" href="https://eliadmin.b-cdn.net" />
      <noscript><link href={FONT_AWESOME_URL} rel="stylesheet" /></noscript>
      <style>{`.grecaptcha-badge { display: none !important; }`}</style>
    </>
  );
}
